import {Modal as MantineModal, ModalProps} from '@mantine/core';
import React from 'react';
import {IoClose} from 'react-icons/io5';
import {CloseButton, Row, Title} from './styles';
import IconButton from '../icon-button';
import {useTheme} from 'styled-components';

interface Props extends ModalProps {
  opened: boolean;
  onClose: () => void;
  title?: string;
  backgroundColor?: string;
  overlayBackgroundColor?: string;
  titleBar?: {
    title: string;
    actionButton?: {
      label: string;
      onClick: () => void;
      icon: React.ReactNode;
    };
  };
}

const Modal: React.FC<Props> = ({
  children,
  backgroundColor,
  size,
  titleBar,
  overlayBackgroundColor = 'rgba(0, 0, 0, .4)',
  withCloseButton,
  ...props
}) => {
  const {colors} = useTheme();

  return (
    <MantineModal
      {...props}
      transitionProps={{transition: 'slide-down', duration: 400}}
      size={size ?? 'xl'}
      styles={{
        title: {fontSize: 18},
        header: {padding: '20px 15px'},
        content: {backgroundColor: backgroundColor ?? colors.card},
        overlay: {backgroundColor: overlayBackgroundColor},
      }}
      withCloseButton={!!props.title}
      title={
        titleBar ? (
          <Row>
            <Title>{titleBar.title}</Title>
            {titleBar.actionButton && (
              <IconButton variant="filled" {...titleBar.actionButton} />
            )}
          </Row>
        ) : (
          props.title ?? ''
        )
      }>
      {!props.title && withCloseButton && (
        <CloseButton onClick={props.onClose}>
          <IoClose size={22} />
        </CloseButton>
      )}
      {children}
    </MantineModal>
  );
};

export default Modal;
